import { render, staticRenderFns } from "./VolumeOverviewChartBar.vue?vue&type=template&id=f915b07a&scoped=true"
import script from "./VolumeOverviewChartBar.vue?vue&type=script&lang=js"
export * from "./VolumeOverviewChartBar.vue?vue&type=script&lang=js"
import style0 from "./VolumeOverviewChartBar.vue?vue&type=style&index=0&id=f915b07a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f915b07a",
  null
  
)

export default component.exports